import { render, staticRenderFns } from "./PopupPriority.vue?vue&type=template&id=4240a948&"
import script from "./PopupPriority.vue?vue&type=script&lang=ts&"
export * from "./PopupPriority.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports